import {TreatmentTarget} from './treatment_target'
export class EndpointTreatment extends TreatmentTarget {
    
    constructor() {
      super();
    }
    
    setTarget(target) {
      this.target = target
    }

    validate() {
      let response = {}
      this.querySelectorAll('input').forEach((input) => { 
        input.classList.remove("error")
        if(input.value === "") {
          input.classList.add("error")
          response.requiredMissing = true 
        }
      });
      return response;
    }

    getData() {
      let ring_to_number = this.querySelector("input").value;
      let target = 
        { 
          target_name: `Ring ${ring_to_number}`,
          target_type: "ENDPOINT", 
          ring_to_endpoint: ring_to_number,
          ivr_target_audio_id: null,
          ivr_choice_timeout: null,
          children: [],
          actions: []
        }
      return target;
    }

    getIcon() {
      return 'fa-phone'
    }

    static getType() {
      return "ENDPOINT"
    }

    connectedCallback() {
      this.innerHTML = `
        <div class="col-sm-12 ct_action" data-action_type=ENDPOINT>
          <div class="panel panel-default">
              <h4>Ring Number</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
              <div class="form-group">
                <label>Number to Call</label>
                <input is="ring-to-endpoint" type="text" class="form-control ring_to_number" data-key="ring_to_number" placeholder="(123) 444-5566 or SIP Target" value="${this.target != null ? this.target.ring_to_endpoint : ""}">
              </div>
          </div>
        </div>
        <div class="col-sm-12 ct_line">
          <div class="ct_vertical_arrow"></div>
          <div class="option_text">Sales Rep is being Called</div>
          <div class="ct_vertical_arrow">
            <div class=arrow-down></div>
          </div>
        </div>
      `;
      super.connectedCallback();
    }
  }
  customElements.define('ring-number-treatment', EndpointTreatment);